<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="d-flex justify-content-center">
        <div
          class="alert alert-warning justify-content-center align-items-center"
          style="width: 100%;"
        >
          <span class="font-weight-bold text-danger">توجه:</span>
          <span class="mr-1"
            >تمامی مبالغ به
            <span class="font-weight-bold">تومان</span> می‌باشد.</span
          >
        </div>
      </div>
      <div class="card-header  border-0">
        <h5 class="card-title font-bold py-3">گزارش وضعیت هدایای کیف پول</h5>
        <div style="flex: 1"></div>
        <button @click="print" class="btn btn-primary">
          <span
            style="transform: translateY(3px)"
            class="feather-printer"
          ></span>
        </button>

        <ExcelDownload class="mr-3" :url="excelUrl" />
      </div>
      <div class="row px-4 not-in-print">
        <form
          autocomplete="chrome-off"
          @submit.prevent="doFilter"
          class="col-12 row"
        >
          <div class="col-4">
            <DatePickerRange
              :fromFormatType="'YYYY-MM-DD'"
              :toFormatType="'YYYY-MM-DD'"
              :fromType="'date'"
              :toType="'date'"
              :dfFType="'jYYYY-jMM-jDD'"
              :dfTType="'jYYYY-jMM-jDD'"
              v-model="filter.date"
            />
          </div>
          <CustomerSearch
            :showLabel="false"
            class="col-md-5"
            :disabled="disabled"
            v-model="filterSelectedCustomer"
          />
          <b-form-group class="col-4">
            <div class="d-flex">
              <label
                @click="() => (used_gift_balance = used_gift_balance ? 0 : 1)"
                class="ml-2"
                >نمایش استفاده شده ها</label
              >
              <b-form-checkbox
                :unchecked-value="0"
                :disabled="disabled"
                :value="1"
                v-model="used_gift_balance"
              />
            </div>
          </b-form-group>
          <div class="col-3">
            <button :disabled="disabled" type="submit" class="btn btn-primary">
              فیلتر
            </button>
          </div>
        </form>
      </div>
      <div id="print" class="p-4">
        <div class="print-only">
          <h4>فروشگاه الینور</h4>
        </div>
        <br />
        <div class="d-flex mb-3 mr-2-print">
          <span class="ml-1 font-bold">گزارش وضعیت هدایای کیف پول</span>
          <div v-if="appliedFilter.date.startDate">
            <span>از</span>
            <span class="font-weight-bold mx-1">تاریخ</span
            ><span> {{ appliedFilter.date.startDate | persianDate }}</span>
          </div>
          <div class="mr-3" v-if="appliedFilter.date.endDate">
            <span>تا</span>
            <span class="font-weight-bold mx-1">تاریخ</span
            ><span> {{ appliedFilter.date.endDate | persianDate }} </span>
          </div>
        </div>
        <b-table
          id="main-table"
          v-if="reports"
          bordered
          striped
          :fields="fields"
          :items="reports"
          responsive="sm"
        >
          <template v-slot:cell(index)="data">
            {{ data.index + 1 + (page - 1) * perPage }}
          </template>
          <template v-slot:cell(customer)="data">
            <router-link
              v-if="data.item.customer && data.item.customer.name"
              :to="'/admin/customers/show/' + data.item.customer.id"
              >{{ data.item.customer.name }}</router-link
            >
            <span v-else>-</span>
          </template>
          <template v-slot:cell(title_action)="data">
            {{ data.item.action ? data.item.action.title : "-" }}
          </template>
          <template v-slot:cell(type_action)="data">
            {{
              data.item.action.type == "free_shipping"
                ? "ارسال رایگان"
                : "شارژ کیف پول"
            }}
          </template>
          <template v-slot:cell(gift_balance)="data">
            {{ data.item.gift_balance | price }}
          </template>
          <template v-slot:cell(used_gift_balance)="data">
            {{ data.item.used_gift_balance | price }}
          </template>
          <template v-slot:cell(remaining_balance)="data">
            {{ data.item.remaining_balance | price }}
          </template>
          <template v-slot:cell(order_amount)="data">
            {{ data.item.order_amount | price }}
          </template>
          <template v-slot:cell(is_expired)="data">
            {{ data.item.is_expired ? "منقضی شده" : "منقضی نشده" }}
          </template>
          <template v-slot:cell(created_at)="data">
            {{ data.item.created_at | persianDate }}
          </template>
          <template v-slot:cell(start_date)="data">
            {{ data.item.start_date | persianDate }}
          </template>
          <template v-slot:cell(end_date)="data">
            {{ data.item.end_date | persianDate }}
          </template>
          <template #bottom-row="data">
            <b-td colspan="4">جمع کل:</b-td>
            <b-td>{{ totals.total_gift_balance | price }}</b-td>
            <b-td>{{ totals.total_used_gift_balance | price }}</b-td>
            <b-td>{{ totals.total_remaining_balance | price }}</b-td>
            <b-td>*</b-td>
            <b-td>*</b-td>
            <b-td>*</b-td>
            <b-td>*</b-td>
          </template>
        </b-table>

        <div v-if="reports && !reports.length" class="alert alert-primary">
          اطلاعاتی موجود نیست
        </div>
      </div>
      <b-pagination
        v-if="totalRows > perPage"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        class="mt-3 mb-6"
        @change="loadData"
      />
      <div class="d-flex flex-column w-100"></div>
    </div>
  </main>
</template>

<script>
import mixins from "@@/core/mixins/mixins";
import {
  BTable,
  BFormGroup,
  BFormInput,
  BTd,
  BPagination,
  BFormCheckbox,
} from "bootstrap-vue";

import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
import ExcelDownload from "@@/core/components/excelDownload/ExcelDownload";
import CustomerSearch from "@@/core/components/shared/CustomerSearch/CustomerSearch";
function Filter() {
  this.date = {
    startDate: "",
    endDate: "",
  };
}

Filter.prototype.set = function(filters) {
  Object.entries(filters).forEach(([index, value]) => {
    this[index] = value;
  });
};

export default {
  name: "walletGiftsActionStatus",
  mixins: [mixins],
  components: {
    ExcelDownload,
    DatePickerRange,
    BTable,
    BTd,
    CustomerSearch,
    BFormGroup,
    BFormInput,
    BPagination,
    BFormCheckbox,
  },
  data() {
    return {
      disabled: false,
      totals: false,
      fields: [
        {
          key: "index",
          label: "ردیف",
        },
        {
          key: "customer",
          label: "مشتری",
        },
        {
          key: "title_action",
          label: "عنوان عملیات",
        },
        {
          key: "type_action",
          label: "نوع عملیات",
        },
        {
          key: "gift_balance",
          label: "هدیه داده شده",
        },
        {
          key: "used_gift_balance",
          label: "هدیه استفاده شده",
        },
        {
          key: "remaining_balance",
          label: "مانده (محاسبه شده)",
        },
        {
          key: "order_amount",
          label: "مبلغ سفارش",
        },
        {
          key: "start_date",
          label: "تاریخ شروع",
        },
        {
          key: "end_date",
          label: "تاریخ انقضا",
        },
        {
          key: "is_expired",
          label: "وضغیت انقضا",
        },
        {
          key: "created_at",
          label: "تاریخ ثبت",
        },
      ],
      page: 1,
      perPage: 200,
      reports: null,
      sortBy: null,
      filterSelectedCustomer: "",
      sortDesc: null,
      filter: new Filter(),
      appliedFilter: new Filter(),
      used_gift_balance: false,
      currentPage: 1,
      perPage: 15,
      totalRows: 0,
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    // extraQuery() {
    //   return {
    //     start_date: this.filter.date.startDate,
    //     end_date: this.filter.date.endDate,
    //   };
    // },
    // totalRows() {
    //   return this.reports ? this.reports.length : 0;
    // },
    excelUrl() {
      const params = {
        page: this.currentPage,
        from_date: this.appliedFilter.date.startDate
          ? this.appliedFilter.date.startDate
          : "",
        to_date: this.appliedFilter.date.endDate
          ? this.appliedFilter.date.endDate
          : "",
        customer_id:
          this.filterSelectedCustomer && this.filterSelectedCustomer.id
            ? this.filterSelectedCustomer.id
            : "",
        used_gift_balance: this.used_gift_balance,
      };

      const queryString = Object.entries(params)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join("&");

      return `admin/customer-actions/wallet-report?${queryString}`;
    },
  },
  methods: {
    print() {
      window.print();
    },
    doFilter() {
      this.loadData();
    },
    async loadData(page = this.currentPage) {
      try {
        this.appliedFilter.set(this.filter);
        this.disabled = true;

        const today = new Date();
        const startOfToday = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate(),
          0,
          0,
          0,
        );

        function formatDate(date) {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");

          return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        }
        if (
          !this.appliedFilter.date.startDate ||
          !this.appliedFilter.date.endDate
        ) {
          this.appliedFilter.date.startDate = formatDate(startOfToday);
          this.appliedFilter.date.endDate = formatDate(today);
        }

        const response = await this.$axios.get(
          "admin/customer-actions/wallet-report",
          {
            params: {
              page: page,
              from_date: this.appliedFilter.date.startDate
                ? this.appliedFilter.date.startDate
                : "",
              to_date: this.appliedFilter.date.endDate
                ? this.appliedFilter.date.endDate
                : "",
              customer_id:
                this.filterSelectedCustomer && this.filterSelectedCustomer.id
                  ? this.filterSelectedCustomer.id
                  : "",
              used_gift_balance: this.used_gift_balance,
            },
          },
        );
        this.reports = response.data.items.data;
        this.totals = response.data.totals;
        this.currentPage = response.data.items.current_page;
        this.perPage = response.data.items.per_page;
        this.totalRows = response.data.items.total;
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
  },
};
</script>
<style>
.print-only {
  display: none;
}
@media print {
  .not-in-print {
    display: none !important;
  }

  .app-content .side-app {
    padding: 0 !important;
  }

  .print-only {
    display: flex;
    justify-content: center;
  }

  body * {
    visibility: hidden;
  }
  #print,
  #print * {
    visibility: visible;
    font-size: 1.25rem;
  }
  #print {
    padding: 0 !important;
  }
  #print {
    width: 100%;
  }

  #print .not-in-print {
    display: none;
  }

  .mr-2-print {
    margin-right: 20px;
  }
}
</style>
